import { NgClass, isPlatformBrowser } from '@angular/common';
import {
  Component,
  DOCUMENT,
  HostListener,
  inject,
  Inject,
  OnInit,
  PLATFORM_ID,
  signal,
} from '@angular/core';
import { RouterLink, ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SecondarySideMenuI } from '../../../../shared/interfaces/secondary-side-menu.interface';
import { COURSE_SECTION_SIDE_MENU_ITEMS } from './constants/side-menu.constant';

@Component({
  selector: 'app-course-side-menu',
  imports: [TranslateModule, NgClass, RouterLink],
  templateUrl: './course-side-menu.component.html',
  styleUrl: './course-side-menu.component.scss',
})
export class CourseSideMenuComponent implements OnInit {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private readonly platformID: Object
  ) {}

  private router = inject(Router);
  public route = inject(ActivatedRoute);
  sideMenuItems = COURSE_SECTION_SIDE_MENU_ITEMS;
  isSideMenuOpen = signal<boolean>(false);

  ngOnInit(): void {
    this.initScreenType();
  }

  public getSideMenuItemIcon(sideMenuItem: SecondarySideMenuI) {
    return this.router.url.endsWith('/' + sideMenuItem.route(''))
      ? sideMenuItem.activeIcon
      : sideMenuItem.nonActiveIcon;
  }

  public isCurrentRouteActive(sideMenuItem: SecondarySideMenuI) {
    return this.router.url.endsWith('/' + sideMenuItem.route(''));
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event & { target: { innerWidth: number } }) {
    this.isSideMenuOpen.update(
      () => event.target?.innerWidth <= 700 && event.target?.innerWidth >= 500
    );
  }

  initScreenType() {
    if (isPlatformBrowser(this.platformID)) {
      this.isSideMenuOpen.update(
        () =>
          this.document.defaultView!.innerWidth <= 700 &&
          this.document.defaultView!.innerWidth >= 500
      );
    }
  }
}
